export enum SourcingRequestStatus {
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
}
